














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ToggleSwitch extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop(String) readonly label?: string

  handleChange(checked: boolean): void {
    this.$emit('input', checked)
  }
}
